export interface DynamicFormModel {
  model: { [key: string]: unknown };
  dirty: boolean;
  status: string;
  errors: unknown;
}
